import { render, staticRenderFns } from "./audits.vue?vue&type=template&id=01810e88&"
import script from "./audits.vue?vue&type=script&lang=js&"
export * from "./audits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports